import { SignUp } from '@clerk/clerk-react'

export default function Signup() {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex flex-1 items-center justify-center px-4 py-12">
        <SignUp
          routing="path"
          path="/sign-up"
          signInUrl="/sign-in"
          forceRedirectUrl="/dashboard"
          fallback={<p className="text-sm text-ica-text">Loading sign up...</p>}
        />
      </div>
    </div>
  )
}
